import { Flex, Text, Box, AspectRatio } from "@chakra-ui/react";
import React from "react";
import Image, { type StaticImageData } from "next/legacy/image";
import { trackEvent } from "lib/analytics";
import { Balancer } from "react-wrap-balancer";
import { Button } from "ui/button";
import { Section } from "./section";

type CustomersHeroProps = {
  title: string;
  image: StaticImageData;
  imageAlt?: string;
  description?: string;
  actionTitle: string;
  actionHref: string;
};

export function CustomersHero({ title, image, imageAlt, description, actionTitle, actionHref }: CustomersHeroProps) {
  return (
    <Section my={{ base: 12, md: 16 }}>
      <Flex align="center" justify="space-between" direction={{ base: "column", lg: "row" }} gap={{ base: 12, xl: 24 }}>
        <Box flex={1} textAlign={{ base: "center", lg: "left" }} maxW={{ base: "3xl", lg: "100%" }} mx="auto">
          <Text as="h1" textStyle="h3">
            <Balancer>{title}</Balancer>
          </Text>

          <Text as="h2" fontSize="lg" mt={8} mb={12}>
            {description}
          </Text>

          <Flex align="center" justify={{ base: "center", lg: "start" }} gap={4}>
            <Button
              hasRightChevron
              href={actionHref}
              onClick={() => {
                trackEvent("Customers Hero CTA Clicked");
              }}
            >
              {actionTitle}
            </Button>
          </Flex>
        </Box>

        <Box pos="relative" flex={1} w="100%" maxW="560px">
          <AspectRatio ratio={4 / 3} w="100%">
            <Image priority src={image} alt={imageAlt ?? "Hero image."} layout="fill" objectFit="contain" />
          </AspectRatio>
        </Box>
      </Flex>
    </Section>
  );
}
